var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Approval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.74 39A5.45 5.45 0 0068 35.5a5.51 5.51 0 00-5.5-5.5H47V14.5a5.5 5.5 0 00-11 0V17c0 7.53-5 13-12 13h-5a2 2 0 00-2 2v24a2 2 0 002 2h5.47L31 61.74a2 2 0 001 .26h20.5a5.51 5.51 0 005.5-5.5 5.72 5.72 0 00-.21-1.5h4.71a5.51 5.51 0 005.5-5.5 5.45 5.45 0 00-1.26-3.5 5.49 5.49 0 000-7zM47 41h15.5a1.5 1.5 0 110 3H47a2 2 0 000 4h15.5a1.5 1.5 0 110 3H47a2 2 0 000 4h5.5a1.5 1.5 0 110 3h-20L26 54.26a2 2 0 00-1-.26h-4V34h3c9.12 0 16-7.31 16-17v-2.5a1.5 1.5 0 113 0V34h19.5a1.5 1.5 0 110 3H47a2 2 0 000 4zm-33-8v22a3 3 0 01-6 0V33a3 3 0 016 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Approval.597cb622.svg";
export { SvgK1Approval as ReactComponent };